import { AverageMonthlyIncome } from "../"

export interface ModifyAverageMonthlyIncome {
    countryCode: string;
    income: number;
    isDeleted: boolean;
}

export class ModifyAverageMonthlyIncomeFactory {
    static from(averageMonthlyIncome: AverageMonthlyIncome): ModifyAverageMonthlyIncome {
        const modifyAverageMonthlyIncome: ModifyAverageMonthlyIncome = JSON.parse(
            JSON.stringify({
                countryCode: averageMonthlyIncome.countryCode,
                income: averageMonthlyIncome.income,
                isDeleted: false
            })
        )
        return modifyAverageMonthlyIncome
    }
}

enum ModifyAverageMonthlyIncomeKeys {
    CountryCode = "countryCode",
    Income = "income",
    IsDeleted = "isDeleted",
}

export function ModifyAverageMonthlyIncomeObject() {
    return {
        CountryCode: ModifyAverageMonthlyIncomeKeys.CountryCode,
        Income: ModifyAverageMonthlyIncomeKeys.Income,
        IsDeleted: ModifyAverageMonthlyIncomeKeys.IsDeleted,
    }
}

export function ModifyEmptyAverageMonthlyIncomeErrorsObject(): { [key: string]: boolean } {
    return {
        [ModifyAverageMonthlyIncomeKeys.CountryCode]: false,
        [ModifyAverageMonthlyIncomeKeys.Income]: false,
        [ModifyAverageMonthlyIncomeKeys.IsDeleted]: false,
    };
}
